import React from 'react'

import { CardTemplate } from '../../../../components/CardTemplate'
import { PanelContainer } from '../../../../components/Panel'
import { getConfigTranslation } from '../../../../utils/helper/getConfigTranslation'
import { useConfigContext } from '../../../ui-config/context'
import { useDespatchAdviceById } from '../../data'

type Props = {
  id: string
}

export const Header: React.FC<Props> = ({ id }) => {
  const { uiConfig: config } = useConfigContext()
  const { data: despatchAdvice, isLoading } = useDespatchAdviceById(id)

  return (
    <PanelContainer
      header={getConfigTranslation(config.despatchAdvice.header.title)}
      id="despatchAdvice-header"
      visible={config.despatchAdvice.header.enabled}
    >
      <div className="grid">
        {/* buyer */}
        <CardTemplate
          title={getConfigTranslation(
            config.despatchAdvice.header.buyerInformation.title,
          )}
          data={despatchAdvice?.Payload.BuyerInformation}
          config={config.despatchAdvice.header.buyerInformation}
          isLoading={isLoading}
        />

        {/* seller */}
        <CardTemplate
          title={getConfigTranslation(
            config.despatchAdvice.header.sellerInformation.title,
          )}
          data={despatchAdvice?.Payload.SellerInformation}
          config={config.despatchAdvice.header.sellerInformation}
          isLoading={isLoading}
        />

        {/* billing */}
        <CardTemplate
          title={getConfigTranslation(
            config.despatchAdvice.header.billingInformation?.title,
          )}
          data={despatchAdvice?.Payload.BillingInformation}
          config={config.despatchAdvice.header.billingInformation}
          isLoading={isLoading}
        />

        {/* shipping */}
        <CardTemplate
          title={getConfigTranslation(
            config.despatchAdvice.header.shippingInformation.title,
          )}
          data={despatchAdvice?.Payload.ShippingInformation}
          config={config.despatchAdvice.header.shippingInformation}
          isLoading={isLoading}
        />
      </div>
    </PanelContainer>
  )
}
